<div class="page" [class.sidebar-visible]="showSidebar" [class.sidebar-hidden]="!showSidebar">
  <div class="sidebar" *ngIf="showSidebar">
    <app-nav-menu></app-nav-menu>
  </div>

  <main [style.margin-left.px]="showSidebar ? 250 : 0" [style.width]="showSidebar ? 'calc(100% - 250px)' : '100%'">
    <article class="content px-4">
      <router-outlet></router-outlet>
    </article>
  </main>
</div>

